import React, { useState } from 'react';
import Modal from '@ui-library/modal/custom';
import OtpInput from 'react-otp-input';
import ErrorLabel from '@ui-library/errorLabel';
import Timer from '@components/common/util/timer';
import Button from '@ui-library/button';
import { CatchErr } from '@utils/types';
import useStores from '@stores/useStores';
import { Subtext } from '@ui-library/typography';
import classes from './otp.module.scss';
import { useSendOtp } from '@auth/common/hooks';

interface Props {
  submit: (otp: string) => void;
  cancel: () => void;
  loading: boolean;
  error: string | null;
}

export default ({ submit, cancel, loading, error }: Props) => {
  const sendOtp = useSendOtp();
  const { userStore, messagesStore } = useStores();
  const [otp, setOtp] = useState('');
  const [showTimer, setShowTimer] = useState(true);

  const handleSubmit = () => {
    submit(otp);
  };

  const handleCancel = () => {
    cancel();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (otp.length === 6 && event.key === 'Enter') {
      handleSubmit();
    }
    event.stopPropagation();
  };

  const handleResendCode = async () => {
    try {
      await sendOtp(userStore.sessionData, userStore?.phoneNumber);
      setShowTimer(true);
    } catch (e: CatchErr) {
      messagesStore!.showErrorMessage(e.message);
    }
    window.rudderanalytics.track('Resend Otp code clicked', { email: userStore?.email });
  };

  const inputClass = [classes.input];
  if (error) {
    inputClass.push(classes.error_input);
  }

  return (
    <Modal
      title="Enter OTP sent to your number"
      content={
        <div onKeyDown={handleKeyDown}>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            isInputNum
            shouldAutoFocus
            inputStyle={inputClass.join(' ')}
            containerStyle={classes.input_container}
          />
          <ErrorLabel error={!!error} errorMessage={error || ''} />
          <Subtext className="m-t-sm">
            Did not receive code?{' '}
            {showTimer ? (
              <span>
                Please wait <Timer time={30} timeUp={() => setShowTimer(false)} /> to send another
              </span>
            ) : (
              <Button textPrimary onClick={handleResendCode} name="Send another" />
            )}
          </Subtext>
        </div>
      }
      onClose={handleCancel}
      onSave={handleSubmit}
      isSaveDisabled={otp.length !== 6}
      loading={loading}
      saveLabel="Submit"
      showClose
      size="sm"
    />
  );
};
